<template>
  <span>
    <HqDrawer
      :title="status == 'add'?'新增':(status == 'detail' ? '查看详情' :'编辑')"
      :visible.sync="drawerVisible"
      size="70%"
      ref="drawer"
      @on-cancel="cancel"
    >
      <div style="width: 90%;margin: 0 auto;padding: 12px 0 100px 0" class="pageform">
        <el-form ref="form" :model="form" :rules="addruleValidate">

          <el-row :gutter="24">
            <el-col :span="24">
              <p class="section_title">学员信息</p>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="orderNo">
                <v-text-field
                  v-model="form.orderNo"
                  label="学员订单号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="studentName">
                <v-text-field
                  v-model="form.studentName"
                  label="学员姓名"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  readonly
                  @click.native="onOpenChoiceStudent"
                  
                  suffix-icon="el-icon-search"
                  :disabled="status != 'add'"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <StudentOrder ref="studentOrderModalRef" @on-ok="onGoodsDrawerOk" :visible.sync="showStudentOrderModal" />

            <!-- <el-col :span="12">
              <el-form-item prop="sex">
                <dict-select code="SEX">
                  <v-select
                    v-model="form.sex"
                    slot-scope="props"
                    :items="props.dictData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="性别"
                    item-text="label"
                    item-value="label"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    :disabled="status == 'detail' || status == 'passEdit'"
                  ></v-select>
                </dict-select>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item prop="mobilePhone">
                <v-text-field
                  v-model="form.mobilePhone"
                  label="学员手机号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item prop="idcard">
                <v-text-field
                  v-model="form.idcard"
                  label="学员身份证号"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="12">
              <el-form-item prop="educationName">
                <dict-select code="EDUCATION_TYPE">
                  <v-select
                    v-model="form.educationName"
                    slot-scope="props"
                    :items="props.dictData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="学历"
                    item-text="label"
                    item-value="label"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    disabled
                  ></v-select>
                </dict-select>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item prop="subscribeSchoolName">
                <v-text-field
                  v-model="form.subscribeSchoolName"
                  label="成交校区"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="goodsName" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.goodsName"
                  label="报读商品"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="12">
              <el-form-item prop="admissionsTeacherId">
                <v-text-field
                  v-model="form.admissionsTeacher"
                  label="招生老师"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  disabled
                ></v-text-field>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <p class="section_title">就业确认信息</p>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="interviewPosition">
                <v-autocomplete
                  v-model="form.interviewPosition"
                  :items="jobNameList"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="面试职位"
                  item-text="name"
                  item-value="name"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  clear-icon="$clear"
                  hide-details="auto"
                  @change="changeJobName"
                  no-data-text="暂无数据"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="employmentCompany" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.employmentCompany"
                  label="就业企业"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-text-field>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="monthlyPay" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.monthlyPay"
                  label="试用期月薪"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="12">
              <el-form-item prop="employmentCtiy">
                <v-autocomplete
                  v-model="form.employmentCtiy"
                  :items="cityList"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="就业城市"
                  item-text="name"
                  item-value="name"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  clear-icon="$clear"
                  hide-details="auto"
                  @change="changeCity"
                  no-data-text="暂无数据"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-autocomplete>
              </el-form-item>
            </el-col> -->

            <!-- <el-col :span="12">
              <el-form-item prop="employmentState">
                <v-autocomplete
                  v-model="form.employmentState"
                  :items="employmentStateList"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="就业状态"
                  item-text="name"
                  item-value="name"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  clear-icon="$clear"
                  hide-details="auto"
                  @change="changeEmploymentState"
                  no-data-text="暂无数据"
                  :disabled="status == 'detail' || status == 'passEdit'"
                ></v-autocomplete>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-tooltip class="item" effect="dark" content="指一个订单的就业次数" placement="top-start">
                <el-form-item prop="employmentNum">
                  <v-autocomplete
                    v-model="form.employmentNum"
                    :items="employmentNumList"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="就业次数"
                    item-text="name"
                    item-value="name"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    @change="changeemploymentNum"
                    no-data-text="暂无数据"
                    :disabled="status == 'detail' || ( !historyNoEmploymentTime && status == 'passEdit')"
                  ></v-autocomplete>
                </el-form-item>
              </el-tooltip>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="employmentTime">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="form.employmentTime"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.employmentTime"
                      label="学员就业时间"
                      hide-details="auto"
                      outlined
                      :dense="true"
                      :height="32"
                      :clearable="true"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="status == 'detail' || ( !historyNoEmploymentTime && status == 'passEdit')"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.employmentTime" no-title locale="zh-cn">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">取消</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(form.employmentTime)">
                      确认
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item prop="pass">
                <v-autocomplete
                  v-model="form.pass"
                  :items="passList"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="是否转正"
                  item-text="name"
                  item-value="id"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  clear-icon="$clear"
                  hide-details="auto"
                  @change="changeEmploymentPass"
                  no-data-text="暂无数据"
                  :disabled="status == 'detail'"
                ></v-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="form.pass == 1">
              <el-form-item prop="passTime">
                <v-menu
                  ref="turn"
                  v-model="turn"
                  :close-on-content-click="false"
                  :return-value.sync="form.passTime"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.passTime"
                      label="转正时间"
                      hide-details="auto"
                      outlined
                      :dense="true"
                      :height="32"
                      :clearable="true"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :disabled="status == 'detail'"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.passTime" no-title locale="zh-cn">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="turn = false">取消</v-btn>
                    <v-btn text color="primary" @click="$refs.turn.save(form.passTime)">
                      确认
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="form.pass == 1">
              <el-form-item prop="passPay" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.passPay"
                  label="转正月薪"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="status == 'detail'"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="status == 'add' || status == 'edit'">
              <el-form-item prop="employmentTeacherId">
                <teacher-select>
                  <v-autocomplete
                    v-model="form.employmentTeacherId"
                    slot-scope="props"
                    :items="props.teacherData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="就业老师"
                    item-text="userName"
                    item-value="userId"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    @change="changeEmploymentTeacher"
                    no-data-text="暂无数据"
                    :disabled="status == 'detail' || status == 'passEdit'"
                  ></v-autocomplete>
                </teacher-select>
                
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="status == 'detail' || status == 'passEdit'">
              <el-form-item prop="employmentTeacher">
                <teacher-select>
                  <v-autocomplete
                    v-model="form.employmentTeacher"
                    slot-scope="props"
                    :items="props.teacherData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="就业老师"
                    item-text="userName"
                    item-value="userName"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    @change="changeEmploymentTeacher"
                    no-data-text="暂无数据"
                    :disabled="status == 'detail' || status == 'passEdit'"
                  ></v-autocomplete>
                </teacher-select>
                
              </el-form-item>
            </el-col>

            <!-- <el-col :span="12">
              <el-form-item prop="admissionsTeacherId">
                <teacher-select>
                  <v-select
                    v-model="form.admissionsTeacher"
                    slot-scope="props"
                    :items="props.teacherData"
                    :menu-props="{ bottom: true, offsetY: true }"
                    label="招生老师"
                    item-text="userName"
                    item-value="userName"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    clear-icon="$clear"
                    hide-details="auto"
                    disabled
                  ></v-select>
                </teacher-select>
              </el-form-item>
            </el-col> -->
            
            <el-col :span="24">
              <el-form-item prop="img">
                <div class="upload-box upload-box-daikuan">
                  <el-upload
                    class="avatar-uploader"
                    v-if="imgList.length < 8 && status !== 'detail'"
                    :action="imgUploadDK.host"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess()"
                    :data="imgUploadDK"
                    :before-upload="beforeAvatarUpload()"
                    auto-upload
                    :http-request="uploadRequest()"
                    >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div style="position:relative;display: flex;" v-if="imgList.length>0">
                    <span v-for="(item,index) in imgList" style="position:relative; margin-right:10px;">
                      <el-image 
                        :key="index"
                        class="avatar"
                        style="object-fit:contain"
                        :src="item" 
                        :preview-src-list="[item]">
                      </el-image>
                      <div @click="removePic(index)" v-if="status !== 'detail'" style="cursor: pointer;font-size:20px;color:#fff;line-height:26px;text-align:center;position:absolute;border-radius:13px; width:26px;height:26px; right:-10px;top:-10px; background-color:red">x</div>

                    </span>
                  </div>

                </div>
              </el-form-item>
            </el-col>

            <!-- <el-col :span="24" v-if="form.pass == 1">
              <el-form-item prop="img">
                <div class="upload-box upload-box-pass">
                  <el-upload
                    class="avatar-uploader"
                    v-if="imgVoucherList.length < 3 && status !== 'detail'"
                    :action="imgVoucherUploadDK.host"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess()"
                    :data="imgVoucherUploadDK"
                    :before-upload="beforeAvatarUpload2()"
                    auto-upload
                    :http-request="uploadRequest2()"
                    >
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                  <div style="position:relative;display: flex;" v-if="imgVoucherList.length>0">
                    <span v-for="(item,index) in imgVoucherList" style="position:relative; margin-right:10px;">
                      <el-image 
                        :key="index"
                        class="avatar"
                        style="object-fit:contain"
                        :src="item" 
                        :preview-src-list="[item]">
                      </el-image>
                      <div @click="removePic2(index)" v-if="status !== 'detail'" style="cursor: pointer;font-size:20px;color:#fff;line-height:26px;text-align:center;position:absolute;border-radius:13px; width:26px;height:26px; right:-10px;top:-10px; background-color:red">x</div>

                    </span>
                  </div>

                </div>
              </el-form-item>
            </el-col> -->

            <el-col :span="24">
              <el-form-item prop="remark">
                <v-textarea
                  v-model="form.remark"
                  outlined
                  :height="80"
                  name="input-7-4"
                  label="备注"
                  value=""
                  :disabled="status == 'detail'"
                ></v-textarea>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- form.excellentPlan=='1'是否培优商品 -->
          <el-row :gutter="24" v-if="form.excellentPlan=='1'">
            <el-col :span="24">
              <p class="section_title">陪跑信息</p>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="previousSalary" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.previousSalary"
                  label="陪跑前月薪"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="form.signType=='1' || status == 'detail' || status == 'passEdit'"
                ></v-text-field>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="expectedSalary" style="margin-bottom: 44px">
                <v-text-field
                  v-model="form.expectedSalary"
                  label="陪跑后月薪"
                  hide-details="auto"
                  outlined
                  :dense="true"
                  :height="32"
                  :clearable="true"
                  :disabled="form.signType=='1' || status == 'detail' || status == 'passEdit'"
                ></v-text-field>
              </el-form-item>
            </el-col>

            <el-col :span="24" style="position: relative; margin-top: -18px;">
              <div style="height:22px;line-height:50px;">就业薪资目标</div>
              <span style="display:inline-block; height:22px;line-height:50px;margin-top:0px;margin-bottom: 30px">经双方确认，学员在本服务期内的就业薪资目标为：人民币</span>
              <el-col :span="12" style="position: absolute; left: 375px; top:25px;">
                <el-form-item prop="targetSalary" style="display:inline-block;width: 120px;">
                  <v-text-field
                    v-model="form.targetSalary"
                    hide-details="auto"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    :disabled="form.signType=='1' || status == 'detail' || status == 'passEdit'"
                  ></v-text-field>
                </el-form-item>
                <span style="margin-left:10px;">元/月（税前）。</span>
              </el-col>
              
            </el-col>

            <el-col :span="24" style="position: relative;">
              <div style="height:22px;line-height:50px;">确认方式</div>
              <div style="display:inline-block; height:22px;line-height:50px;margin-bottom: 30px">本人现在确认符合以下不退费情形的第</div>
              <el-col :span="12"  style="position: absolute; left: 250px; top:25px;vertical-align: top;">
                <el-form-item prop="treaty" style="display:inline-block;width: 100px;">
                  <v-text-field
                    v-model="form.treaty"
                    hide-details="auto"
                    outlined
                    :dense="true"
                    :height="32"
                    :clearable="true"
                    :disabled="form.signType=='1' || status == 'detail' || status == 'passEdit'"
                  ></v-text-field>
                </el-form-item>
                <span style="margin-left:10px;">条约定，确定协议约定不退费。</span>
              </el-col>
              
            </el-col>

            <el-col :span="24" style="padding-right:0;position: relative;">
              <div style="height:22px;line-height:50px;">不退费情形</div>
              <div style="height:22px;line-height:50px;">学员确认，若出现以下任一情形，将不予退费</div>
              <div style="height:22px;line-height:50px;">（1）学员在服务期内已达到上述约定的薪资目标；</div>
              <div style="height:22px;line-height:50px;">（2）学员因主观原因不参加学习、不完成作业、不配合就业陪跑服务、不参加面试或拒绝就业机会；</div>
              <div style="height:22px;line-height:50px;">（3）学员在就业后自愿接受低于约定薪资的工作，并实际到岗就业；</div>
              <div style="height:22px;line-height:50px;">（4）学员因个人原因中途放弃就业或退出计划；</div>
              <div style="height:22px;line-height:50px;">（5）学员提供虚假信息或材料，影响就业推荐或薪资核实。</div>

              <div style="position:absolute;right:0;bottom:0;" v-if="status == 'detail'">
                <el-button size="mini" type="primary" round @click="qianXieyi" :loading="btnLoading" v-if="checkSigned === 'false'">学员签约</el-button>
                <el-button size="mini" type="primary" round @click="signDetail" :loading="btnLoading" v-if="checkSigned === 'true'">查看协议</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button v-if="status != 'detail'" @click="save" type="primary" :loading="btnLoading">确认</el-button>
      </div>


       <!-- 协议 弹窗-->
      <el-dialog title="在线签约学员就业薪资确认单" center :visible.sync="rsModalVisible" width="620px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" class="fenqi-xieyi">
        <div class="modal-wrapper">
          <div class="modal-wrapper-post" style="padding:0">
            <div class="post-content" ref="postImg">
              <div class="post-content-body">
                <div  class="goods-img" alt="" ></div>
                <!-- <div  class="goods-img" :style="{backgroundImage: `url(${Formmoney.classImg})`}" alt="" ></div> -->
                <div>
                    <p class="goods-name">{{form.goodsName }}</p>
                    <p  class="rules">{{form.id}}</p>
                    <!-- <p v-if="Formmoney.businessId == 1" class="rules">{{Formmoney.goodsDetail || ' '}}</p> -->
                    <!-- <h3 v-if="Formmoney.businessId === 0 || Formmoney.businessId === '0'" class="rules" style="margin-left:5px">
                      <span>{{Formmoney.major}}, {{Formmoney.academicLevel}}</span>
                    </h3> -->
                    <p class="stu-name">
                      <span>报名学员</span>
                      <span>{{form.studentName}}</span>
                    </p>
                </div>
                <div class="post-content-bottom">
                  <div id="qrcode_heyue" ref="qrcode_heyue" class="qr-code"></div>
                  <div class="tips">
                    <img  style="margin-bottom:6px" src="@/assets/image/fingerprint.png" alt="">
                    <p>长按识别二维码</p>
                    <p>立即签约《学员</p>
                    <p>就业薪资确认单》</p>
                  </div>
                </div>
              </div>
            
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="onCloseXieyi">关闭</el-button>
          <el-button size="small" type="primary" @click="getPostImg" :loading="btnLoading">下载海报</el-button>
        </span>
      </el-dialog>

    </HqDrawer>
  </span>
</template>
<script>
import ValidateType from "@/utils/validate";
import dictSelect from "@/components/dictSelect";
import teacherSelect from "./teacherSelect";
import StudentOrder from "./modelStudentOrder";
import { getResTeachList } from "api/public";

import { doJiamiSeePhone } from "api/customer";
import Strhide from "@/utils/strhide";
import Crypto from "@/utils/crypto";

import { getCityList } from "@/api/count";
import { 
  getEmploymentPositionList, 
  employmentInformationAdd, 
  employmentInformationUpdate, 
  getPeiyouXieyiSignUrl, 
  getPreviewUrlForBestSign,
  getHistroyEmploymentInformation, 
} from "@/api/count";
import { formatTimes,formatTimesFileName, formatTimesHour } from "@/utils/timeDate";
import { getOrderListPage } from "api/order/change";

import axios from 'axios'
import md5 from 'md5';

import QRCode from "qrcodejs2";
import html2canvas from 'html2canvas';

export default {
  name: "addEditDetail",
  components: {
    dictSelect,
    teacherSelect,
    StudentOrder
  },
  props: {
    method: {
      type: Function
    }
  },
  data() {
    return {
      imgList: [],
      imgVoucherList: [],
      status: 'add',// 'add'/'edit'/'detail'/'passEdit'
      noJiamiPhone:'',// 11位学员手机号
      drawerVisible: false,
      showStudentOrderModal: false,
      isGoCexiao: false,// 是否调用撤销接口
      rsModalVisible: false,// 打开协议弹窗
      checkSigned: null, //  true ：已签署,false:未签署
      orderStuentUserId: null,// 学员id
      studentOrderId:null,// 订单id
      qr: null,
      historyNoEmploymentTime: false,//判断历史数据是否没有选择【就业时间】
      histroyPromise: null, // 历史就业信息接口进行中的 Promise，供校验器等待
      form: {
        orderNo: '',
        studentName: '',
        sex: '',
        mobilePhone: '',
        idcard: '',
        education: '',//新加
        educationName: '',
        subscribeSchoolName: '',
        goodsName: '',

        interviewPosition: '',
        employmentCompany: '',
        monthlyPay: '',
        passPay: '',
        employmentCtiy: '',
        employmentState: '',

        employmentNum: '',
        employmentTime: '',
        pass: null,
        passTime: '',
        passType: null, // 审批通过后，原先转正为否但要修改为是，半置灰标识符

        employmentTeacher: '',
        employmentTeacherId: '',

        admissionsTeacher: '',
        admissionsTeacherId: '',
        remark: '',
        // scaleImgUrl: '',
        photoUrl: '',

        voucherUrl: null,//凭证

        previousSalary: '', //陪跑前金额
        expectedSalary: '', //陪跑后金额
        targetSalary: '',//目标金额
        treaty: '',//条约
        salaryTemplateId: null,//协议模板id
        excellentPlan: '',// 培优标识
      },
      HistroyForm: {
        passId: '',// 转正对应的就业单号
        id: '',// 最新就业单号
        employmentNum:'',//最新一条就业次数 
        passTime:'',//历史最新转正时间
        employmentTime:'',//最新就业时间
        status:'',//最新就业申请审批状态（申请单未审批前是空值）
        goodsKeyWord: '',//腾飞、薪火、黑马、猎鹰的商品 2次就业日期必须在1次就业日期的6个月之后
        nextCheck: false, // 特殊处理，当次新增不用间隔6个月
      },
      // isShowPeiyou: false,
      Formmoney: {},

      cityList:[],
      jobNameList:[],
      teacherList:[],//老师列表
      employmentStateList:[
        {id: 1, name: '就业成功'},
        {id: 2, name: '培训中'},
        {id: 3, name: '待业中'},
      ],
      employmentNumList:[
        {id: 1, name: '1'},
        {id: 2, name: '2'},
        {id: 3, name: '3'},
        {id: 4, name: '4'},
        {id: 5, name: '5'},
      ],
      passList:[
        {id: '0', name: '否'},
        {id: '1', name: '是'},
      ],
      // addruleValidate: {
      //   studentName: [
      //     { message: '请选择学员', required: true }
      //   ],
      //   employmentState: [
      //     { message: '请选择就业状态', required: true }
      //   ],
      //   monthlyPay: [
      //     { validator: ValidateType.money5, trigger: 'change', required: false, }
      //   ],
      //   passPay: [
      //     { validator: ValidateType.money5, trigger: 'change', required: false, }
      //   ],
      //   employmentNum: [
      //     { message: '请选择就业次数', required: true }
      //   ],
      //   employmentTime: [
      //     { message: '请选择就业时间', required: true }
      //   ],
      //   pass: [
      //     { message: '请选择是否转正', required: true }
      //   ], 
      //   previousSalary: [
      //     { validator: ValidateType.money5, trigger: 'blur', required: this.form.excellentPlan == '1', }
      //   ],
      //   expectedSalary: [
      //     { validator: ValidateType.money5, trigger: 'blur', required: this.form.excellentPlan == '1', }
      //   ],
      //   targetSalary: [
      //     { validator: ValidateType.money5, trigger: 'blur', required: this.form.excellentPlan == '1', }
      //   ],
      //   treaty: [
      //     { validator: ValidateType.number1_5, trigger: 'blur', required: this.form.excellentPlan == '1', }
      //   ],
      // },
      imgUploadDK: {
        //商品名字
        name: '',
        //路径
        key: "",
        OSSAccessKeyId: "",
        success_action_status:200,
        expire : "",
        host : "https://hq-tianyi.hqjy.com",
        policy : '',
        signature : ''
      },
      stopUpload: false,
      imgVoucherUploadDK: {
        //商品名字
        name: '',
        //路径
        key: "",
        OSSAccessKeyId: "",
        success_action_status:200,
        expire : "",
        host : "https://hq-tianyi.hqjy.com",
        policy : '',
        signature : ''
      },
      stopUpload2: false,
      menu: false, // 就业时间控件开关
      turn: false, // 转正时间控件开关
      btnLoading: false,// 是否提交成功
    };
  },
  computed: {
    addruleValidate() {
      // 选择学员后，判断学员订单号的就业申请是否审批（排除编辑状态时，最新就业单id == 编辑id）
      const validateStudentName = (rule, val, cb) =>  {
        // 非必填，如果为空或空字符串，直接通过
        if(val === null || val === undefined || val === '') {
          return cb(new Error("请选择学员"))
        }
        if(this.HistroyForm.id && this.HistroyForm.id != this.form.id && this.HistroyForm.status===null && !this.HistroyForm.employmentTime && !this.HistroyForm.employmentNum){
          return cb();
        }else if (this.HistroyForm.id && this.HistroyForm.id != this.form.id && this.HistroyForm.status != 1) {
          this.$message.error(`该学员订单存在未审批通过的就业单`);
          return cb(new Error(`该学员订单存在未审批通过的就业单`));
        } else {
          return cb();
        }
      };
      // 就业次数
      const validateEmploymentNum = async (rule, value, cb) => {
        if (value === null || value === undefined || value === '') {
          return cb(new Error('请选择就业次数'));
        }
        // 历史就业信息尚未返回时，等待接口完成后再做次数对比
        if (this.histroyPromise) {
          try {
            await this.histroyPromise
          } catch (e) {
            return cb(new Error('历史就业信息加载失败，请重试'));
          }
        }
        // 将值转换为数字
        const numValue = Number(value);
        if (this.HistroyForm.employmentNum && numValue <= this.HistroyForm.employmentNum && this.HistroyForm.id != this.form.id) {//新增
          return cb(new Error(`该订单已选过${numValue}次就业数`));
        }else if (this.HistroyForm.employmentNum && numValue < this.HistroyForm.employmentNum && this.HistroyForm.id == this.form.id) {//编辑
          return cb(new Error(`该订单已选过${numValue}次就业数`));
        } else {
          return cb();
        }
      };
      // 是否转正（只允许就业次数为1时，填写一次转正）
      const validatePass = (rule, value, cb) => {
        if(!this.form.employmentNum){
          this.form.pass = ''
          return cb(new Error('请先选择就业次数'));
        }
        if (value === null || value === undefined || value === '') {
          return cb(new Error('请选择是否转正'));
        }
        if (this.HistroyForm.passId  == this.form.id && this.form.employmentNum < 2) {//编辑1次 
          return cb();
        }else if(value==1 && this.form.employmentNum > 1 && this.HistroyForm.passTime){
          return cb(new Error(`该订单首次就业已填报转正，第${this.form.employmentNum}次就业不可再次填写转正信息`));
        }else if(value==1 && this.form.employmentNum > 1){
          return cb(new Error(`只能首次就业填报转正，第${this.form.employmentNum}次就业不可填写转正信息`));
        }else {
          if(value==0){
            this.form.passTime=''
            // 清空转正时间后，重新校验学员就业时间
            this.$refs['form'].validateField('employmentTime')
          }
          return cb();
        }
      };
      // 就业日期
      const validateEmploymentTime = (rule, value, cb) => {
        if (value === null || value === undefined || value === '') {
          return cb(new Error('请选择就业时间'));
        }
        if (this.HistroyForm.employmentTime) {//
          if (value < this.HistroyForm.employmentTime) {//新增
            return cb(new Error(`就业时间不能小于${this.HistroyForm.employmentNum}次就业时间`));
          }
          if(this.HistroyForm.goodsKeyWord && this.HistroyForm.employmentTime){// 腾飞、薪火、黑马、猎鹰
            const days30Later = new Date(this.HistroyForm.employmentTime);
            days30Later.setDate(days30Later.getDate() + 30);
            if(new Date(value) <= new Date(days30Later) && !this.HistroyForm.nextCheck){//判断转正日式 是否在 30天之后
              let days30LaterStr = formatTimesHour(days30Later)
              return cb(new Error(`该订单是${this.HistroyForm.goodsKeyWord}商品，需在${this.HistroyForm.employmentNum}次就业时间的30天后才能提交，就业时间为${days30LaterStr}之后`));
            }
          }
        }
        
        if (this.form.passTime) {//存在转正时间
          const threeMonthsLater = new Date(value);
          threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
          console.log('【threeMonthsLater】',threeMonthsLater, this.form.passTime > threeMonthsLater)
          if(value > this.form.passTime){
            return cb(new Error(`就业时间不能大于转正时间`));
          }else if(new Date(this.form.passTime) > new Date(threeMonthsLater)){//判断转正日式 是否在 threeMonthsLater之后
            return cb(new Error(`就业时间和转正时间最长不超过3个月`));
          }else {
            return cb();
          }
        }
        return cb()
      };
      // 转正日期
      const validatePassTime = (rule, value, cb) => {
        if (value === null || value === undefined || value === '') {
          return cb(new Error('请选择转正日期'));
        }
        if (this.form.passTime) {//存在转正时间
          const threeMonthsLater = new Date(this.form.employmentTime);
          threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
          console.log('【threeMonthsLater】',threeMonthsLater, this.form.passTime > threeMonthsLater)
          if(this.form.employmentTime > value){
            return cb(new Error(`就业时间不能大于转正时间`));
          }else if(new Date(this.form.passTime) > new Date(threeMonthsLater)){//判断转正日式 是否在 threeMonthsLater之后
            return cb(new Error(`就业时间和转正时间最长不超过3个月`));
          }else {
            return cb();
          }
        }else{
          return cb();
        }
      };
      return{
        studentName: [
          { message: '请选择学员', required: true },
          { validator: validateStudentName, trigger: 'change' }
        ],
        employmentState: [
          { message: '请选择就业状态', required: true }
        ],
        interviewPosition: [
          { message: '请选择面试职位', trigger: 'change', required: true }
        ],
        employmentCompany: [
          { message: '请输入就业企业', trigger: 'change', required: true }
        ],
        employmentCtiy: [
          { message: '请选择就业城市', trigger: 'change', required: true }
        ],
        monthlyPay: [
          { validator: ValidateType.moneyMust5, trigger: 'change', required: true, }
        ],
        passPay: [
          { validator: ValidateType.moneyMust5, trigger: 'change', required: false, }
        ],
        employmentNum: [
          { message: '请选择就业次数', trigger: 'change', required: true },
          { validator: validateEmploymentNum, trigger: 'change' }
        ],
        employmentTime: [
          { message: '请选择就业时间', required: true },
          { validator: validateEmploymentTime, trigger: 'change' }
        ],
        pass: [
          { message: '请选择是否转正', required: true },
          { validator: validatePass, trigger: 'change' }
        ],
        passTime: [
          { message: '请选择转正时间', required: true },
          { validator: validatePassTime, trigger: 'change' }
        ],
        employmentTeacherId: [
          { message: '请选择就业老师', required: true }
        ],
        previousSalary: [
          { validator: ValidateType.moneyMust5, trigger: 'blur', required: this.form.excellentPlan == '1', }
        ],
        expectedSalary: [
          { validator: ValidateType.moneyMust5, trigger: 'blur', required: this.form.excellentPlan == '1', }
        ],
        targetSalary: [
          { validator: ValidateType.moneyMust5, trigger: 'blur', required: this.form.excellentPlan == '1', }
        ],
        treaty: [
          { validator: ValidateType.number1_5, trigger: 'blur', required: this.form.excellentPlan == '1', }
        ],
        
      }
    },
  },
  mounted() {
    this.getAllList()
  },
  methods: {
    changeJobName(value) {
      this.jobNameList.map(item => {
        if(item.id === value) {
          this.form.interviewPosition = item.id
        }
      })
    },
    changeCity(value){
      this.cityList.map(item => {
        if(item.name === value) {
          this.form.employmentCtiy = item.name
        }
      })
    },
    changeEmploymentState(value){
      this.employmentStateList.map(item => {
        if(item.name === value) {
          this.form.employmentState = item.name
        }
      })
      this.$refs['form'].validate()
      
    },
    changeemploymentNum(value){
      this.employmentNumList.map(item => {
        if(item.name === value) {
          this.form.employmentNum = item.name
        }
      })
      this.$refs['form'].validate()
      
    },
    changeEmploymentPass(value){
      this.passList.map(item => {
        if(item.id === value) {
          this.form.pass = item.id
        }
      })
      this.$refs['form'].validate()
      
    },
    changeAdmissionsTeacher(value) {// 招生老师
      // console.log('招生老师',value)
      // this.$forceUpdate();
      this.teacherList.map(item => {
        if(item.userId === value) {
          this.form.admissionsTeacherId = item.id
          this.form.admissionsTeacher = item.userName
        }
      })
    },
    changeEmploymentTeacher(value) {// 就业老师
      // console.log('就业老师',value)
      this.teacherList.map(item => {
        if(item.userId === value) {
          this.form.employmentTeacherId = item.userId
          this.form.employmentTeacher = item.userName
        }
      })
    },
    // 以前没有就业老师userId的重新匹配获取
    // 为获取就业老师userId以老师名匹配出对应的userId
    async GetMatchEmploymentTeacherId() {
      // console.log('就业老师',value)
      this.teacherList.map(item => {
        if(item.userName === this.form.employmentTeacher) {
          this.form.employmentTeacherId = item.userId
        }
      })
    },
    // 获取一开始的下拉框来源
    getAllList(){
      this.getTeacherList()
      this.getCityList()
      this.getEmploymentPositionList()
    },
    // 获取老师 -下拉框来源
    async getTeacherList() {
      const res = await getResTeachList()
      this.teacherList = res.result
    },
    // 获取城市 -下拉框来源
    async getCityList() {
      const resCity = await getCityList({name:'',limit:999})
      if(resCity.code == 0){
        this.cityList = resCity.result.records
      }
    },
    // 获取面试职位 -下拉框来源
    async getEmploymentPositionList() {
      let params = {
        page: 1,
        limit: 100,
        code: '',
        name: '',
        remark: '',
      }
      const { code, result} = await getEmploymentPositionList(params)
      if (code == 0) {
        this.jobNameList = result.records
      } 
    },

    onOpenChoiceStudent(row){
      this.showStudentOrderModal = true;
      this.$refs.studentOrderModalRef.init(row)
    },
    // 选择学员弹窗完毕
    async onGoodsDrawerOk(val) {
      console.log('[选中学员]', val);

      this.form.orderNo = val.orderNo
      this.form.studentName = val.userName? val.userName : val.studentName // 学员姓名
      this.form.mobilePhone = val.mobilePhone ? val.mobilePhone : val.phone
      this.form.idcard = val.idCard
      this.form.educationName = val.educationName // 学历名字
      this.form.education = val.education // 学历[新增 ]id
      this.form.subscribeSchoolName = val.subscribeSchoolName ? val.subscribeSchoolName : val.dealSchoolName //成交校区
      this.form.goodsName = val.goodsName ? val.goodsName : val.itemName
      this.form.admissionsTeacher = val.teacherRecruitName ? val.teacherRecruitName : val.teacherName//招生老师
      this.form.admissionsTeacherId = val.teacherRecruitId ? val.teacherRecruitId : val.teacherPk//招生老师id
      this.form.salaryTemplateId = val.salaryTemplateId//协议模板
      this.form.excellentPlan = val.excellentPlan//培优标识
      if(val.excellentPlan && val.excellentPlan=='1'){
        // //携带姓名，账号
        // this.Formmoney.stuName   =  val.userName? val.userName : val.studentName // 学员姓名
        // this.Formmoney.stuMobile =  val.mobilePhone ? val.mobilePhone : val.phone
        // // this.Formmoney.classImg  = this.createCode.classImg;
        // this.Formmoney.commodityName =  val.goodsName ? val.goodsName : val.itemName
        // // this.Formmoney.goodsDetail =  this.createCode.goodsDetail;
        // // this.Formmoney.classAndName = this.createCode.classAndName
        // this.Formmoney.orderId   =  val.orderNo
        // this.Formmoney.userId    =  val.userId;
        // this.Formmoney.businessId = val.businessId;
        // // this.Formmoney.academicLevel = this.createCode.academicLevel;
        // // this.Formmoney.major = val.major;
      }
      // 显示非加密手机号
      if(val.newPhone){
        this.noJiamiPhone = val.newPhone
      }else{
        let str = val.customerId.toString()
        let res = await doJiamiSeePhone(Crypto.encrypt(Strhide.getKeyHide(),Strhide.getIvHide(), str))
        this.noJiamiPhone = res.result
      }
      // 根据选择的学员查询历史历史就业统计审批单
      this.getHistroyEmploymentInformation()
      
      this.$refs['form'].validate()
    },
    // 腾飞、薪火、黑马、猎鹰的商品 2次就业日期必须在1次就业日期的6个月之后
    findGoodsKeyword(text) {
      let keywords = ['腾飞', '薪火', '黑马', '猎鹰']
      // 1. 遍历数组，找到首个匹配的关键词
      let firstMatch = null;
      for (let i = 0; i < keywords.length; i++) {
        if (text.includes(keywords[i])) {
          firstMatch = keywords[i];
          // matchIndex = i;
          break; // 找到第一个就停止
        }
      }
      return firstMatch // 首个匹配的关键词（如果没有则为null）
    },
    // 获取学员订单对应的历史就业单信息
    async getHistroyEmploymentInformation(){
      const promise = this._fetchHistroyEmploymentInformationWithRetry()
      this.histroyPromise = promise
      try {
        await promise
      } finally {
        if (this.histroyPromise === promise) {
          this.histroyPromise = null
        }
      }
    },
    // 接口失败时自动重试，避免网络抖动导致历史数据未加载
    async _fetchHistroyEmploymentInformationWithRetry(retryTimes = 3){
      for (let attempt = 1; attempt <= retryTimes; attempt++) {
        try {
          await this._fetchHistroyEmploymentInformation()
          return
        } catch (e) {
          if (attempt === retryTimes) {
            throw e
          }
          await new Promise(resolve => setTimeout(resolve, 1000))
        }
      }
    },
    async _fetchHistroyEmploymentInformation(){
      const params = {
        orderNo: this.form.orderNo,
        ...this.form.id ? {id: this.form.id} : {}
      }
      const { code, msg, result } = await getHistroyEmploymentInformation(params)
      if (code == 0 && result) {
        const {passId, id ,employmentNum, passTime, employmentTime, status, nextCheck } = result
        this.HistroyForm = {
          passId: passId,// 转正对应的就业单号
          id: id,// 最新就业单号
          employmentNum: employmentNum,//最新一条就业次数 
          passTime: passTime,//历史最新转正时间
          employmentTime: employmentTime,//最新就业时间
          status: status,//最新就业申请审批状态（申请单未审批前是空值）
          goodsKeyWord: this.findGoodsKeyword(this.form.goodsName),
          nextCheck: nextCheck && nextCheck == 1 ? true : false
        }
        console.log('this.HistroyForm',this.HistroyForm)
      } else {
        this.HistroyForm = {
          passId: '',// 转正对应的就业单号
          id: '',// 最新就业单号
          employmentNum:'',//最新一条就业次数 
          passTime:'',//历史最新转正时间
          employmentTime:'',//最新就业时间
          status:'',//最新就业申请审批状态（申请单未审批前是空值）
          goodsKeyWord: '',//商品关键词
          nextCheck: false
        }
      }
      this.$refs['form'].validate()// 为了选择订单后有正则提示
    },
    // 编辑初始化
    init(status,row) {
      this.HistroyForm = {
        employmentNum:'',//最新一条就业次数 
        passTime:'',//历史最新转正时间
        employmentTime:'',//最新就业时间
        status:'',//最新就业申请审批状态（申请单未审批前是空值）
      }
      this.historyNoEmploymentTime = false
      this.$refs.drawer.init()
      this.status = status// 'add'/'edit'/'detail'/'passEdit'
      if(status != 'add'){
        let rowData = JSON.parse(JSON.stringify(row))
        this.form = JSON.parse(JSON.stringify(row))
        console.log('this.form',this.form)
        this.noJiamiPhone = rowData.mobilePhone
        this.form.mobilePhone = this.formatJiamiPhone(this.form.mobilePhone)
        this.imgList = this.stringToArray(this.form.photoUrl)
        this.imgVoucherList = this.stringToArray(this.form.voucherUrl)
        this.form.pass = rowData.pass=='是'? '1' :'0' 
        this.form.employmentTeacherId = this.form.employmentTeacherId*1
        // if(this.form.excellentPlan=='1'){ // 是培优需要签陪跑协议的商品
          this.checkPeipaoXieyiSigned() //协议是否已经签署
          this.GetOrderListMatch()
          
        // }
        if(status != 'detail'){
          if(!rowData.employmentTeacherId){
            this.GetMatchEmploymentTeacherId()
          }
        // 判断是否可以重新编辑转正后（即修改否转正+ 转正时间+转正月薪+上传图片+修改备注，然后其他置灰不能修改，编辑修改点击提交后首次先调用撤销api再更新保存api）
          // 情况1：审批通过+之前是否转正选择了否+就业时间（选了12月，然后1,2月这样是可以的），以上条件同时成立的话。
          // 情况2：passType == '1'标识符  + （row.status空值或-1 || 2驳回 || 3撤销 )
          if(rowData.status == 1 && rowData.pass == '否'){
            if(!row.employmentTime){
              this.historyNoEmploymentTime = true;
            }
            const employmentTime = new Date(row.employmentTime);//就业时间
            const currentTime = new Date();// 当前时间
            // 获取年份和月份
            const yearE = employmentTime.getFullYear();
            const monthE = employmentTime.getMonth();
            const yearC = currentTime.getFullYear();
            const monthC = currentTime.getMonth();
            const isTimeOK = (yearC > yearE) || (yearC === yearE && monthC > monthE);
            if(isTimeOK){
              this.status = 'passEdit'// 半置灰
              this.isGoCexiao = true; // 判断是否首次先调用撤销api
              // this.form.passType = '1'
            }
          }
          if(rowData.passType && rowData.passType=='1'){
            this.status = 'passEdit'// 半置灰
          }
          // 根据选择的学员查询历史历史就业统计审批单
          // this.getHistroyEmploymentInformation()
        }
        this.getHistroyEmploymentInformation()
      }else if(status === 'add'){
        this.form = {
          orderNo: '',
          studentName: '',
          sex: '',
          mobilePhone: '',
          idcard: '',
          education: '',//新加
          educationName: '',
          subscribeSchoolName: '',
          goodsName: '',

          interviewPosition: '',
          employmentCompany: '',
          monthlyPay: '',
          passPay: '',
          employmentCtiy: '',
          employmentState: '',

          employmentNum: null,
          employmentTime: '',
          pass: null,
          passTime: '',
          passType: null, // 审批通过后，原先转正为否但要修改为是，半置灰标识符

          employmentTeacher: '',
          employmentTeacherId: '',

          admissionsTeacher: '',
          admissionsTeacherId: '',
          remark: '',
          // scaleImgUrl: '',
          photoUrl: '',
          voucherUrl: null,

          previousSalary: '', //陪跑前金额
          expectedSalary: '', //陪跑后金额
          targetSalary: '',//目标金额
          treaty: '',//条约
          salaryTemplateId: null,//协议模板id
          excellentPlan: '',// 培优标识
        }
        this.imgList.splice(0, this.imgList.length)
        this.imgVoucherList.splice(0, this.imgVoucherList.length)
      }
      this.$nextTick(() => {
        this.$refs['form'].clearValidate();
      });
    },
    formatJiamiPhone(str) {
      const phone = String(str);
      if(phone.length==11){
        // 使用正则替换：捕获前3位和最后4位，中间的所有字符替换为4个星号
        return phone.replace(/^(.{3}).*(.{4})$/, '$1****$2');
      }else{
        return '';
      }
    },

    // 保存
    save(isXieyi) {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          if(this.form.pass =='1' && !this.form.passTime ){
            this.$message.error(`请选择转正时间！`);
            return false;
          }

          if( this.imgList.length==0 ){
            this.$message.error(`请上传jpg、jpeg、png的图片附件！`);
            return false;
          }
          // if( this.form.pass==1 && this.imgVoucherList.length==0 ){
          //   this.$message.error(`请上传jpg、jpeg、png的凭证附件！`);
          //   return false;
          // }
          if( this.form.pass !== '1' ){
            this.form.passPay = ''
            this.form.passTime = ''
          } 
          if(this.status ==='add'){
            // 新增的时候，存储不加密手机号
            this.form.mobilePhone = this.noJiamiPhone
            this.form.photoUrl = this.arrayToString(this.imgList)
            this.form.voucherUrl = this.arrayToString(this.imgVoucherList)
            this.doAdd()
          }else if(this.status ==='edit' || this.status ==='passEdit'){
            if(this.isGoCexiao && this.form.pass !== '1' ){//审核通过后再次编辑，判断是否会调用撤销Api
              this.$message.error(`本次是转正后修改，请将【是否转正】选择为: 是`);
              return false;
            }
            delete this.form.mobilePhone// 编辑时不再传参手机号，由于编辑时为加密手机号，传参后会覆盖数据库原来的不加密手机号
            delete this.form.createId// 编辑时不传createId，因为新增时，传id后端把id转化为人名，重新编辑保存会报错
            this.form.photoUrl = this.arrayToString(this.imgList)
            this.form.voucherUrl = this.arrayToString(this.imgVoucherList)
            console.log(this.form)
            this.doEdit()
          }
        }
      })
    },
    // 新增就业申请单后，生成协议记录信息：
    async doXieyiAdd(id){
      const params = {
        orderNo: this.form.orderNo,
        id:id,
        goodsName: this.form.goodsName,
        idcard: this.form.idcard,
        mobilePhone: this.noJiamiPhone,
        studentName: this.form.studentName,
        salaryTemplateId: this.form.salaryTemplateId,
        previousSalary: this.form.previousSalary,
        expectedSalary: this.form.expectedSalary,
        treaty: this.form.treaty,
        targetSalary: this.form.targetSalary,
        createId: this.form.createId
      }
      const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/contract/add`, params,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      console.log('保存调用的协议生成记录接口',res)
      if(res.code == 200) {
        this.btnLoading = false
        this.$message.success('新增成功');
        this.method()// 刷新外层列表
        this.cancel()
      } else {
        this.btnLoading = false
        this.$message.error(res.msg)
      }

    },
    async doAdd(){
      this.form.createId = this.$store.state.user.loginUser.userId
      this.btnLoading = true
      const { code, msg, result } = await employmentInformationAdd(this.form)
      if (code == 0) {
        if(this.form.excellentPlan == '1'){
          this.doXieyiAdd(result.id)
        }else{
          this.btnLoading = false
          this.$message.success('新增成功');
          this.method()// 刷新外层列表
          this.cancel()
        }
      } else {
        this.btnLoading = false
        this.$message.warning(msg);
        this.cancel()
      }
    },
    async doEdit(sysControl){
      
      this.form.updateId = this.$store.state.user.loginUser.userId
      this.form.updateTime = formatTimes(new Date())
      this.form.isExist = 0
      this.btnLoading = true
      if(this.isGoCexiao && this.form.pass == '1' ){// 调用撤销Api
        this.form.status = '3' // 由于前一步执行了撤销，然后详情【状态】有变更，故不用传
        this.form.permission = '' // 由于前一步执行了撤销，然后详情【审批状态】有变更，故不用传
        const params = {
          operationType: 3,
          processInstanceId: this.form.id,
          remark: '系统操作撤销审批，原因为学员转正状态已更新。'
        };
        const result = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/approval`, params,{
            headers:{
              "CrmToken": localStorage.getItem("userToken")
            }
          }).then((res2) => res2.data)
          console.log('撤销result',result)
          if (result.code === 200) {
            const { code, msg } = await employmentInformationUpdate(this.form)
            if(sysControl){
              this.btnLoading = false
              this.method()// 刷新外层列表
              return
            }
            console.log('hahahaha',sysControl)
            if (code == 0) {
              this.btnLoading = false
              this.$message.success('修改成功');
              this.method()// 刷新外层列表
              this.cancel()
            } else {
              this.btnLoading = false
              this.$message.warning(msg);
              this.cancel()
            }
          } else {
            this.btnLoading = false
            this.$message.error(res2.msg);
          }

      }else{
        this.btnLoading = true
        const { code, msg } = await employmentInformationUpdate(this.form)
        if (code == 0) {
          if(sysControl){
            this.btnLoading = false
            this.method()// 刷新外层列表
            return
          }
          this.btnLoading = false
          this.$message.success('修改成功');
          this.method()// 刷新外层列表
          this.cancel()
        } else {
          this.btnLoading = false
          this.$message.warning(msg);
          this.cancel()
        }
      }
    },

    // 取消
    cancel() {
      console.log('点击取消')
      this.btnLoading = false
      this.$refs['form'].clearValidate();
      this.form = {
        orderNo: '',
        studentName: '',
        sex: '',
        mobilePhone: '',
        idcard: '',
        education: '',//新加
        educationName: '',
        subscribeSchoolName: '',
        goodsName: '',

        interviewPosition: '',
        employmentCompany: '',
        monthlyPay: '',
        passPay: '',
        employmentCtiy: '',
        employmentState: '',
        employmentTeacher: '',
        employmentTeacherId: '',

        admissionsTeacher: '',
        admissionsTeacherId: '',
        remark: '',
        // scaleImgUrl: '',
        photoUrl: '',
        
        previousSalary: '', //陪跑前金额
        expectedSalary: '', //陪跑后金额
        targetSalary: '',//目标金额
        treaty: '',//条约
        salaryTemplateId: null,//协议模板id
        excellentPlan: '',// 培优标识
      }
      this.imgList.splice(0, this.imgList.length)
      this.showStudentOrderModal = false;
      this.$refs.drawer.close()
    },
    // 将字符串转换为数组
    stringToArray(str) {
      if(str == '' || str == null){
        return []
      }
      let arrayData = str.split(';');
      return arrayData
    },
    // 将数组转换为字符串
    arrayToString(arr) {
      let outputString = arr.join(';');
      return outputString
    },
    //删除凭证图片
    removePic(index) {
      this.imgList.splice(index, 1)
    },
    //删除凭证图片
    removePic2(index) {
      this.imgVoucherList.splice(index, 1)
    },
    /***
    * 成功上传图片的回调函数。
    * 属于一个高级函数，需要保存是多个上传图片控件的某一个上传的。
    */
    handleAvatarSuccess(type) {
      return ( _, file )=>{
        // this.form.isUploadSuccessDK = true; //已经上传成功
        // this.form.scaleImgUrl = URL.createObjectURL(file.raw);
      }
    },
    /***
    * 图片上传前的检查；
    * 只允许这四种类型的图片上传： ["jpg", "jpeg", "bmp", "png"]
    */
    beforeAvatarUpload( type ){
      let _this = this
      return async ( file )=>{
        _this.stopUpload = true;
        let allowExt = ["jpg", "jpeg", "bmp", "png"];
        let isAllowUpload = allowExt.some( item=>{
            return file.type.indexOf( item ) > -1;
        })

        if (!isAllowUpload) {
          this.$message.error('上传凭证只允许 jpg、jpeg、bmp、png 格式!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
          isAllowUpload = false;
          _this.stopUpload = false;
          
          return isAllowUpload
        }
        console.log('图片上传前的检查_this.stopUpload',_this.stopUpload)

        let len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        console.log('isAllowUpload',this.imgUploadDK)

        const random = this.getRandomNum(10000, 99999)
        
        this.imgUploadDK.name = `${time}${random}.${len[len.length-1]}`

        return isAllowUpload
      }
    },
    uploadRequest(type) {
      return (op) => {
        console.log(123,op,this.stopUpload)
        this.myupload(
          op.file,
          type,
          res => {
            let temp = {
              name: res.attachment,
              url: res.aliyunAddress
            }
            // 成功后的回调，把结果返回，并且把上传列表的状态改变，打上成功的√
            op.onSuccess(temp)
          },
          err => {
            console.log(err)
          },
          res => {
          // 处理进度条的东西，把进度数据传进去实现进度条走动，传参res应该是这样的类型{percent: 48}
            op.onProgress(res)
          }
        )
      }
    },
    myupload(file, type, successCallback = new Function(), errCallBack = new Function(), progressCallback = new Function()) {
      let item = this.form;
      let imgList = this.imgList
      let fileName = file.name
      this.$fetch("ossSigniture", {code: 'tianyi'})
      .then(res => {
        let obj = res.data
        let config = {}
        config.host = obj['host']
        config.policyBase64 = obj['policy']
        config.accessid = obj['accessId']
        config.signature = obj['signature']
        config.expire = parseInt(obj['expire'])
        config.callbackbody = obj['callback']
        config.dir = obj['dir']
        // if(type === "scaleImgDK"){
          this.imgUploadDK.dir = obj.dir
        // }
        

        const random = this.getRandomNum(10000, 99999)
        const len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        const newName = `${time}${random}.${len[len.length-1]}`
        const renameFile = new File([file], newName, {type: file.type, uid: file.uid})
        // this.realFileList.push({uid: file.uid, name: newName})
        let form = new FormData(),
        key = config.dir + md5((this.$route.query.orderId || '') + '' + Date.now(), 8).substr(0, 10) + '_'
        form.append('name', newName)
        form.append('key', `${obj.dir}\${filename}`)
        form.append('policy', obj.policy)
        form.append('OSSAccessKeyId', obj.accessid)
        form.append('expire', obj.expire)
        form.append('host', obj.host)
        form.append('success_action_status', 200)
        form.append('signature', obj.signature)
        form.append('file', renameFile)
        if (config.host.indexOf('http:') > -1) {
          var protocol = window.location.protocol || 'http:'
          var subUrl = config.host.substring(5, config.host.length)
          config.host = protocol + subUrl
        }
        console.log('接口api--this.stopUpload',this.stopUpload)
        if(!this.stopUpload){
          return
        }
        axios({
          url: config.host,
          method: 'POST',
          data: form,
          processData: false,
          cache: false,
          contentType: false,
          onUploadProgress: function(progressEvent) {
            let host = "https://hq-tianyi.hqjy.com";
            // let photoUrl = `${host}/${this.imgUpload.dir}${this.imgUpload.name}`
            let photoUrl = `${host}/${config.dir}${newName}`
            // if(type === "scaleImgDK"){
              // item.photoUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // }
            let imgUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // item.imgList.push[imgUrl]
            if (!imgList.includes(imgUrl)) {
              imgList.push(imgUrl);
            }
            console.log('imgList',imgList,this.stopUpload)
            if (progressEvent.lengthComputable) {
              let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
              progressCallback({ percent: percent })
            }
          }
        })
          .then(() => {
            let size = file.size > 1000000 ? parseFloat(file.size / 1000000).toFixed(2) + 'M' : parseFloat(file.size / 1000).toFixed(2) + 'KB'
            successCallback({
              attachment: fileName,
              aliyunAddress: key,
              size: size
            })
          })
          .catch(err => {
            errCallBack(err)
          })
      })
      .catch(err => {
        errCallBack(err)
        // console.log(err)
      })
    },
    beforeAvatarUpload2( type ){
      let _this = this
      return async ( file )=>{
        _this.stopUpload2 = true;
        let allowExt = ["jpg", "jpeg", "bmp", "png"];
        let isAllowUpload = allowExt.some( item=>{
            return file.type.indexOf( item ) > -1;
        })

        if (!isAllowUpload) {
          this.$message.error('上传凭证只允许 jpg、jpeg、bmp、png 格式!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
          isAllowUpload = false;
          _this.stopUpload2 = false;
          
          return isAllowUpload
        }
        console.log('图片上传前的检查_this.stopUpload2',_this.stopUpload2)

        let len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        console.log('isAllowUpload',this.imgVoucherUploadDK)

        const random = this.getRandomNum(10000, 99999)
        
        this.imgVoucherUploadDK.name = `${time}${random}.${len[len.length-1]}`

        return isAllowUpload
      }
    },
    uploadRequest2(type) {
      return (op) => {
        console.log(123,op,this.stopUpload2)
        this.myupload2(
          op.file,
          type,
          res => {
            let temp = {
              name: res.attachment,
              url: res.aliyunAddress
            }
            // 成功后的回调，把结果返回，并且把上传列表的状态改变，打上成功的√
            op.onSuccess(temp)
          },
          err => {
            console.log(err)
          },
          res => {
          // 处理进度条的东西，把进度数据传进去实现进度条走动，传参res应该是这样的类型{percent: 48}
            op.onProgress(res)
          }
        )
      }
    },
    myupload2(file, type, successCallback = new Function(), errCallBack = new Function(), progressCallback = new Function()) {
      let item = this.form;
      let imgVoucherList = this.imgVoucherList
      let fileName = file.name
      this.$fetch("ossSigniture", {code: 'tianyi'})
      .then(res => {
        let obj = res.data
        let config = {}
        config.host = obj['host']
        config.policyBase64 = obj['policy']
        config.accessid = obj['accessId']
        config.signature = obj['signature']
        config.expire = parseInt(obj['expire'])
        config.callbackbody = obj['callback']
        config.dir = obj['dir']
        // if(type === "scaleImgDK"){
          this.imgVoucherUploadDK.dir = obj.dir
        // }
        

        const random = this.getRandomNum(10000, 99999)
        const len = file.name.split('.')
        const time = formatTimesFileName(new Date()).replace(/-/g, '')
        const newName = `${time}${random}.${len[len.length-1]}`
        const renameFile = new File([file], newName, {type: file.type, uid: file.uid})
        // this.realFileList.push({uid: file.uid, name: newName})
        let form = new FormData(),
        key = config.dir + md5((this.$route.query.orderId || '') + '' + Date.now(), 8).substr(0, 10) + '_'
        form.append('name', newName)
        form.append('key', `${obj.dir}\${filename}`)
        form.append('policy', obj.policy)
        form.append('OSSAccessKeyId', obj.accessid)
        form.append('expire', obj.expire)
        form.append('host', obj.host)
        form.append('success_action_status', 200)
        form.append('signature', obj.signature)
        form.append('file', renameFile)
        if (config.host.indexOf('http:') > -1) {
          var protocol = window.location.protocol || 'http:'
          var subUrl = config.host.substring(5, config.host.length)
          config.host = protocol + subUrl
        }
        console.log('接口api--this.stopUpload2',this.stopUpload2)
        if(!this.stopUpload2){
          return
        }
        axios({
          url: config.host,
          method: 'POST',
          data: form,
          processData: false,
          cache: false,
          contentType: false,
          onUploadProgress: function(progressEvent) {
            let host = "https://hq-tianyi.hqjy.com";
            // let photoUrl = `${host}/${this.imgUpload.dir}${this.imgUpload.name}`
            let photoUrl = `${host}/${config.dir}${newName}`
            // if(type === "scaleImgDK"){
              // item.photoUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // }
            let imgUrl = process.env.VUE_APP_BASE_URL + "/mz_proxy?url="+encodeURI(photoUrl);
            // item.imgVoucherList.push[imgUrl]
            if (!imgVoucherList.includes(imgUrl)) {
              imgVoucherList.push(imgUrl);
            }
            console.log('imgVoucherList',imgVoucherList,this.stopUpload2)
            if (progressEvent.lengthComputable) {
              let percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0
              progressCallback({ percent: percent })
            }
          }
        })
          .then(() => {
            let size = file.size > 1000000 ? parseFloat(file.size / 1000000).toFixed(2) + 'M' : parseFloat(file.size / 1000).toFixed(2) + 'KB'
            successCallback({
              attachment: fileName,
              aliyunAddress: key,
              size: size
            })
          })
          .catch(err => {
            errCallBack(err)
          })
      })
      .catch(err => {
        errCallBack(err)
        // console.log(err)
      })
    },
    getRandomNum(Min,Max) {
      let Range = Max - Min;
      let Rand = Math.random();
      return(Min + Math.round(Rand * Range));
    },
    // 获取协议是否已经签署
    async checkPeipaoXieyiSigned(){
      const params = {
        id: this.form.id,
      }
      const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/contract/checkSigned`, params,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      console.log('是否签署协议',res)
      if(res.code == 200) {
        this.checkSigned = res.data
        console.log('签署',this.checkSigned  ,this.checkSigned === 'false')
      } else {
        this.checkSigned = null
      }
    },
    // --生成签署陪跑协议第三方的URL
    async qianXieyi(){
      let successUrl = `${process.env.VUE_APP_QRCODE}/hqPeipao?orderId=${this.studentOrderId}&userId=${this.orderStuentUserId}&contractRecordId=${this.form.contractRecordId}&employmentId=${this.form.id}`
      var extra = {
          token: this.orderStuentUserId,
          contractRecordId: this.form.contractRecordId,
          contractBizCode: 'EMPLOYMENT_AGREEMENT',
          successUrl:successUrl
      }
      const params = {
        orderNo: this.form.orderNo,
        id: this.form.id,
        goodsName: this.form.goodsName,
        idcard: this.form.idcard,
        mobilePhone: this.noJiamiPhone,
        studentName: this.form.studentName,
        salaryTemplateId: this.form.salaryTemplateId,
        previousSalary: this.form.previousSalary,
        expectedSalary: this.form.expectedSalary,
        treaty: this.form.treaty,
        targetSalary: this.form.targetSalary,
        createId: this.$store.state.user.loginUser.userId,
        extra: JSON.stringify(extra)//附加参数
      }
      this.$hqMessageBox({
        title: '提示',
        message:`确认学员 ${this.form.studentName} 生成签约协议，将锁定陪跑信息`,
      })
      .then(() => {
        this.btnLoading = true
        return new Promise(async (resolve, reject) => {
          const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/contract/signUrl`, params,{
            headers:{
              "CrmToken": localStorage.getItem("userToken")
            }
          }).then((res) => res.data)
          console.log('生成协议URL',res)
          if(res.code == 200) {
            let signUrl = res.data.signUrl
            // let signUrl = "https://t.bestsign.info/pcNj79geHewrF3"
            this.btnLoading = false
            if(![1, 5, 7].includes(this.form.status)){
              if(this.form.hasOwnProperty('signType') && this.form.signType != '1'){
                this.form.signType = '1'
                delete this.form.mobilePhone// 编辑时不再传参手机号，由于编辑时为加密手机号，传参后会覆盖数据库原来的不加密手机号
                delete this.form.createId// 编辑时不传createId，因为新增时，传id后端把id转化为人名，重新编辑保存会报错
                this.doEdit('sysControl')
              }
            }
            this.goOrderManagement(signUrl);
          } else {
            this.signUrl = ''
            this.btnLoading = false
            this.$message.warning(msg);
          }
        })
      })
      .catch(() => {
        console.log("取消");
      })
    },
    // 签约
    goOrderManagement(signUrl) {
      //等下一个runloop再执行。
      this.rsModalVisible = true;
      this.$nextTick(()=>{
        this.crateQrcode(signUrl)
      })
      
    },
    
    // 协议海报弹窗
    // 生成二维码
    crateQrcode(signUrl) {      
      // let params = {
      //   orderId: this.Formmoney.orderId,
      //   userId: this.Formmoney.userId && this.Formmoney.userId.trim()
      // }
      // console.log(this.Formmoney.orderId, params.userId )
      // let qrcodeUrl = `${process.env.VUE_APP_QRCODE}/hqfenqi?orderId=${params.orderId}&userId=${params.userId}&contractRecordId=${this.xieyiCode.toString()}`
      let qrcodeUrl = signUrl
      if( this.qr && typeof this.qr.clear == 'function' ){
        this.qr.clear();
      }
      console.log('生成签约协议二维码')
      this.qr = new QRCode("qrcode_heyue", {
        width:  98,
        height: 98, // 高度
        text: qrcodeUrl, // 二维码内容
        correctLevel: QRCode.CorrectLevel.L
      })
      this.$refs.qrcode_heyue.title = ''//去掉QRCode库设置的title属性

      // this.Formmoney.classImg =  'https://hq-exercitation.hqjy.com/callback/k786SJSX3d.png'
      // this.Formmoney.classImg =  "/mz_proxy?url="+encodeURI(`${this.Formmoney.classImg}?x-oss-process=image/resize,m_lfit,h_138,w_227`);
      // console.log('this.Formmoney.classImg',this.Formmoney.classImg)
    },
    // 关闭协议弹窗
    onCloseXieyi() {
      this.$refs.qrcode_heyue.innerHTML = ""
      this.rsModalVisible = false
      // this.crateQrcode()
    },
    // 生成海报并且下载
    getPostImg() {
      this.btnLoading = true
      html2canvas(this.$refs.postImg, {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        scrollY: -1,
        scrollX: -3,
        width: this.$refs.postImg.clientWidth,
        height: this.$refs.postImg.clientHeight,
        scale: window.devicePixelRatio,
      }).then(canvas => {
        // 转成图片，生成图片地址
        let imgUrl = canvas.toDataURL('image/png');
        const eleLink = document.createElement('a');
        eleLink.href = imgUrl; // 转换后的图片地址
        // 文件名 商品名-班型名-签约_学员姓名_报名时间
        // eleLink.download = '收款海报'
        eleLink.download = `${this.form.id}-${this.form.goodsName}-陪跑协议签约_${this.form.studentName}_${formatTimesFileName(new Date()).replace(/-/g, '')}`
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
        this.btnLoading = false
      });
    },
    // 【查看协议时需要学员id的参数】为获取学员id以订单号查询订单列表匹配出学员id
    async GetOrderListMatch() {
      if (this.form && this.form.hasOwnProperty('orderNo')) {
        let params = {
          orderNo: this.form.orderNo
        }
        const { code, result, msg} = await getOrderListPage(params)
        if (code == 0 && result.list && result.list.length>0) {
          this.orderStuentUserId = result.list[0].userId
          this.studentOrderId = result.list[0].id
          console.log('【studentOrderId】',this.orderStuentUserId)
        } else {
          this.orderStuentUserId = null
        }
      }
    },
    /***
    * 查看协议
    */
    async signDetail() {
      const params = {
        employmentId: this.form.id,
        token: this.orderStuentUserId
      }
      const res = await axios.post(`/qw_school/schoolcj/order/api/employment/apply/getPreviewUrlForBestSign`, params,{
        headers:{
          "CrmToken": localStorage.getItem("userToken")
        }
      }).then((res) => res.data)
      if(res.code == 200 && res.data) {
        window.open(res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 26px !important;
}
::v-deep .el-form-item__error {
  padding-left: 10px !important;
}
.section_title{
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 10px;
}

::v-deep img {
  object-fit: contain;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 36px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #eee;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.pageform {
  .upload-box {
    min-width: 100%;
    height: 100px;
    border: 1px solid #F0F0F3;
    display: flex;
    // justify-content: center;
    align-items: center;
    position: relative;
    margin-right: 15px;

    // &::before {
    //   position: absolute;
    //   content: "图片附件";
    //   left: 10px;
    //   top: -10px;
    //   font-size: 12px;
    //   color: #1976d2;
    // }

    .upload-btn {
      width: 100px;
      height: 100px;
      border: 1px solid #999;
      position: relative;
      cursor: pointer;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 36px;
        background: #999;
        left: 28px;
        top: 12px;
      }
      &::after {
        position: absolute;
        content: "";
        height: 4px;
        width: 36px;
        background: #999;
        left: 12px;
        top: 28px;
      }
    }
    .avatar{
      width: 100px;
      height: 100px;
    }

    .img-box {
      width: 94%;
      height: 96%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .upload-show{
    &::before {
      position: absolute;
      content: "";
      left: 10px;
      top: -10px;
      font-size: 12px;
      color: #1976d2;
    }
  }
  .upload-box-daikuan{
    margin-left: 70px;
    border: 0;
    &::before {
      position: absolute;
      content: "图片附件";
      left: -60px;
      top: -10px;
      font-size: 12px;
      color: #1976d2;
    }
  }

  .upload-box-pass{
    margin-left: 70px;
    border: 0;
    &::before {
      position: absolute;
      content: "转正凭证";
      left: -60px;
      top: -10px;
      font-size: 12px;
      color: #1976d2;
    }
  }
}

// 协议
.modal-wrapper {
  width: 580px;
  background: #fff;
  &-header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 60px;
    padding-left: 30px;
    border-bottom: 1px solid #e1e4eb;
    > h2 {
      margin-right: 12px;
      font-size: 16px;
      font-weight: 700;
      color: #333;
      > span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }
    > p {
      font-size: 14px;
      color: #999;
    }
    > i {
      position: absolute;
      right: 30px;
      font-size: 18px;
      color: #9bacbf;
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        transform: rotate(180deg);
      }
    }
  }
  &-body {

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 50px 60px 50px 60px;
    &-left {
      font-size: 14px;
      color: #666;
      line-height: 21px;
      margin-right: 60px;
      &>h3 {
        margin-bottom: 16px;
        line-height: 30px;
        &>span:first-child {
          display: inline-block;
          text-align: right;
        }
        &>span:last-child {
          color: #333;
        }
        .money {
          color: #F54955 !important;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }



    &-right {
      width: 209px;
      height: 372px;
      opacity: 0.73;
      background: rgba(230,246,242,0.43);
      position: relative;

      #qrcode {
        background: contain;
        overflow: hidden;
      }
      .qrcode-text {
        position: absolute;
        bottom: 10px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: #333;
        line-height: 16px;
        letter-spacing: 1px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
        &>img {
          width: 24px;
          height: 24px;
        }
        &>span {
          font-size: 12px;
          text-align: center;
          color: #777777;
          line-height: 16px;
          letter-spacing: 1px;
          margin-left: 9px;
        }
      }
    }

  }
  .btns {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
  }

  .post-content-header {
    padding: 12px 20px 8px;
    display: flex;
    align-items: center;
    .logo {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        object-fit: contain;
        border: 1px solid #eee;
        border-radius: 20px;
    }
    .title,.space {
      font-size: 14px;
      color: #222;
    }
    .space {
      padding: 0 8px;
    }
    .tip {
      color: #666;
      font-size: 12px;
    }  

  }

  .post-content-body {
    height: 460px;
    position: relative;
    padding: 70px 15px 36px;

    .goods-img {
        margin: 0 12px;
        width:232px;
        height:112px;
        background: url('../../../../assets/image/peipao-bg.png') no-repeat;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100%;
        // background-size: cover;
    }
    
    .goods-name {
      padding: 5px 12px 10px;
      line-height: 18px;
      font-size: 12px;
      color: #333;
      margin-bottom: 0;
    }
    .rules {
      color: #777;
      padding: 4px 12px 10px;
      font-size: 10px;
      line-height: 16px;
      max-height: 7em;
      margin-bottom: 0;
      overflow: hidden;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 2;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }
    .stu-name {
      margin: 0 12px;
      border: 1px solid #eee;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #F0FAFA;
        font-size: 12px;
        border-radius: 4px;
      span:first-child {
        color: #666;
        margin-right: 10px;
      }
      span {
        margin-left: 10px;
        color:#337AFF
      }
      
    }
  }

  .post-content-bottom {
    position: absolute;
    bottom: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 18px;
    margin-bottom: 14px;
    #qrcode_heyue {
      width: 100px;
      height: 100px;
      border: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      overflow: hidden;
    }

    .tips {
        display: flex;
        flex-direction: column;
        position: relative;
        // padding-bottom: 31px;
        margin-left: 25px;
        margin-top: 5px;
        > img {
          width: 38px;
          height: 38px;
          margin: 0 auto;
        }
        p {
          line-height: 20px;
          font-size: 12px;
          color: #666;
        }
    }
  }

  

  &-post {
    padding: 20px 0 0 0;
    .post-content {
      width: 284px;
      height: 504px;
      background: url('../../../../assets/image/online-subscript.png') no-repeat;
      background-size:cover;
      margin: 0px auto;
    }
    .refresh-qrcode {
      position: absolute;
      bottom: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      user-select: none;
      cursor: pointer;
      left: 0;
      > img {
        width: 15px;
        height: 15px;
        transition: 0.3s ease;
        &:hover {
          transform: rotate(180deg);
        }
      }
      > span {
        font-size: 12px;
        font-weight: 400;
        color: #777777;
        margin-left: 15px;
      }
    }
    .btn-wrap {
      border: 1px solid #E1E4EB;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 18px 0 20px;
      margin-top: 18px;

    }
  }
}
::v-deep .el-dialog__header{
  text-align: left;
  .el-dialog__title{
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }
}
</style>
